import InProgressIcon from './component'

export default InProgressIcon
